/* eslint eslint-comments/no-use: off */
/* eslint-disable @github-ui/github-monorepo/require-react-compiler-gates-import */
import {isFeatureEnabled} from '@github-ui/feature-flags'

/**
 * Exported methods in this file are used by the React Compiler's gating feature.
 *
 * Each method should be named in the form `isReactCompiler<FlagName>Enabled` and return a boolean.
 *
 * The React Compiler will call these methods to determine if a given feature flag (gate)
 * is enabled for a file, based on the annotation:
 *
 *   // @react-compiler gate=isReactCompilerDemoMyCustomGateEnabled
 *
 * This will cause the compiler to call `isReactCompilerDemoMyCustomGateEnabled()` at runtime.
 *
 * To add a new gate, export a new function following the naming convention and return
 * the result of your feature flag check.
 *
 * @example
 *   export const isReactCompilerMyCustomGateEnabled = () => {
 *     return isFeatureEnabled('react_compiler_my_custom_gate')
 *   }
 */

/**
 * Safely check if a feature flag is enabled. Returns false if the client environment
 * is not yet initialized (e.g., during SSR or test module initialization).
 */
function safeIsFeatureEnabled(flag: Parameters<typeof isFeatureEnabled>[0]): boolean {
  try {
    return isFeatureEnabled(flag)
  } catch {
    return false
  }
}

export const isReactCompilerDemoMyCustomGateEnabled = () => {
  // @ts-expect-error -- this is a fake flag for show
  return safeIsFeatureEnabled('fake_feature_flag') // this is just an example, you might use something like safeIsFeatureEnabled('react_compiler_demo_my_custom_gate')
}

export const isReactCompilerBlackbirdMonolithEnabled = () => {
  return safeIsFeatureEnabled('react_compiler_blackbird_monolith')
}

export const isReactCompilerRepoCreationEnabled = () => {
  return safeIsFeatureEnabled('react_compiler_repo_creation')
}

export const isReactCompilerRepoDeploymentsEnabled = () => {
  return safeIsFeatureEnabled('react_compiler_repo_deployments')
}

export const isReactCompilerVirtualNetworkSettingsEnabled = () => {
  return safeIsFeatureEnabled('react_compiler_virtual_network_settings')
}

export const isReactCompilerBillingAppEnabled = () => {
  return safeIsFeatureEnabled('react_compiler_billing_app')
}

export const isReactCompilerCopilotForBusinessEnabled = () => {
  return safeIsFeatureEnabled('react_compiler_copilot_for_business')
}

export const isReactCompilerCopilotSpacesEnabled = () => {
  return safeIsFeatureEnabled('react_compiler_copilot_spaces')
}

export const isReactCompilerFilterEnabled = () => {
  return safeIsFeatureEnabled('react_compiler_filter')
}

export const isReactCompilerGithubModelsEnabled = () => {
  return safeIsFeatureEnabled('react_compiler_github_models')
}

export const isReactCompilerIssueViewerEnabled = () => {
  return safeIsFeatureEnabled('react_compiler_issue_viewer')
}

export const isReactCompilerIssuesReactEnabled = () => {
  return safeIsFeatureEnabled('react_compiler_issues_react')
}

export const isReactCompilerLandingPagesEnabled = () => {
  return safeIsFeatureEnabled('react_compiler_landing_pages')
}

export const isReactCompilerMemexEnabled = () => {
  return safeIsFeatureEnabled('react_compiler_memex')
}

export const isReactCompilerReposRulesEnabled = () => {
  return safeIsFeatureEnabled('react_compiler_repos_rules')
}

export const isReactCompilerSecurityCenterEnabled = () => {
  return safeIsFeatureEnabled('react_compiler_security_center')
}

export const isReactCompilerSecurityProductsEnablementEnabled = () => {
  return safeIsFeatureEnabled('react_compiler_security_products_enablement')
}

export const isReactCompilerSwpCoreEnabled = () => {
  return safeIsFeatureEnabled('react_compiler_swp_core')
}

export const isReactCompilerWorkbenchEnabled = () => {
  return safeIsFeatureEnabled('react_compiler_workbench')
}

export const isReactCompilerWorkspaceEditorEnabled = () => {
  return safeIsFeatureEnabled('react_compiler_workspace_editor')
}
